export class FetchCurrentCoordinates {
    static readonly type = '[GEOLOCATION] FetchCoords';
    constructor(){}
}
